import { registerCustomBlockType } from "../../utils/restrict-block-register";
import metadata from "./block.json";
import Edit from "./Edit";
import Save from "./save";

registerCustomBlockType(
  {
    ...metadata,
    edit: Edit,
    save: Save,
    icon: {
      foreground: "#0061FE",
      src: (
        <svg
          id="a"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="m17.4,12.5l-5.5,6.4c-.2.2-.5.4-.8.4h0c-.3,0-.6-.1-.8-.4l-6-6.5c-1-1.1-2.6-3.3-1.2-5.6.6-1.1,1.5-1.7,2.5-2,1-.2,2.1.1,3.1.8.9.6,1.5,1.3,1.7,1.6.4.4,1.1.4,1.5,0,.1-.2.8-1,1.7-1.6.9-.7,1.9-.9,2.8-.9.4,0,.8-.3.8-.7s-.3-.8-.7-.8c-1.3-.1-2.6.3-3.8,1.1-.7.5-1.3,1-1.6,1.4-.4-.4-.9-.9-1.6-1.4-1.4-1-2.9-1.4-4.3-1.1-1.5.5-2.7,1.4-3.5,2.8-1.3,2.3-.8,5,1.4,7.4l6,6.5c.5.5,1.2.8,1.9.8h0c.7,0,1.4-.3,1.9-.9l5.6-6.4c.3-.3.2-.8-.1-1.1-.2-.1-.7-.1-1,.2Z"
            stroke-width="0"
          />
          <path
            d="m22.6,7h-1.9v-1.8c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.8h-1.9c-.4,0-.8.3-.8.8s.3.8.8.8h1.9v1.8c0,.4.3.8.8.8s.8-.3.8-.8v-1.9h1.9c.4,0,.8-.3.8-.8s-.4-.7-.8-.7Z"
            stroke-width="0"
          />
        </svg>
      ),
    },
  },
  {
    removeAncestorInTemplates: ["single-product"],
  }
);
